package meineglasfaser.frontend.www.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import org.jetbrains.compose.web.dom.Article
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Small
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

enum class ProductAudiences(
    val id: String,
    val title: String,
    val description: String,
    val showVat: Boolean,
) {
    PRIVAT(
        id = "privat",
        title = "Ich bin Privatkunde",
        description = "Entdecken Sie Produkte für Ihr Zuhause",
        showVat = true,
    ),
    BUSINESS(
        id = "business",
        title = "Ich bin Geschäftskunde",
        description = "Damit die Firma immer erreichbar ist",
        showVat = false,
    );

    val href: String = "/entdecken/$id"
}

@Page
@Layout(".components.layouts.ShopLayout")
@Composable
fun LandingPage(ctx: PageContext) {
    Div {
        H1 { Text("Prometheus Network") }
        P { Text("Erleben Sie die Zukunft der Internetverbindung mit unserer schnellen und zuverlässigen Glasfaser-Technologie.") }
    }
    Div(attrs = { classes("grid") }) {
        ProductAudiences.entries.forEach { audience ->
            key(audience.id) {
                Article {
                    Header {
                        B { Text(audience.title) }
                    }
                    Div(attrs = { classes("flex-column") }) {
                        Span { Text(audience.description) }
                    }
                    Anchor(href = audience.href, attrs = { role("button") }) {
                        Text("Produkte entdecken")
                    }
                    Footer {
                        Small {
                            if (audience.showVat) {
                                Text("Preise werden inklusiv USt. angezeigt")
                            } else {
                                Text("Preise werden exklusiv USt. angezeigt")
                            }
                        }
                    }
                }
            }
        }
    }
}
